import React from 'react';
import { Table } from 'reactstrap';
import PropTypes from 'prop-types';
import '../scss/_salesHistoryTable.scss';
import { getFormattedCurrency, formatActivityDateWithYear } from './utils';


class SalesHistoryTable extends React.Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        
        this.state = {
            columns: ['Event', 'Date', 'Price', 'Price/SqFt', 'Days on Market'],
            data: props.listing.SalesHistory,
            tableExpanded: false   
        }
    }

    render() {
        const viewMore = this.state.data.length > 5 ? "View "+ (this.state.data.length - 5)  +" More" : "";

        return (<div className='report_table_container w-100'>
            <div className="col-12 mg-topbtm-20">
                <h3 className="report_table_header">Sales History</h3>
            </div>
            <div className="col-12">
                {this.state.data.length > 0 ?
                    <Table responsive borderless className="report_table">
                        <thead style={{ borderBottom: '1px solid #555555'}}>
                            <tr className="report_table_header_row">
                                {this.state.columns.map((columnName) => {
                                    return <th>{columnName}</th>
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((item, i) => {
                                return i <= 4 || this.state.tableExpanded ?
                                    <tr className="report_table_row">
                                        <td><h5>{item.Event}</h5></td>
                                        <td>{formatActivityDateWithYear(item.Date)}</td>
                                        <td>{getFormattedCurrency(item.Price)}</td>
                                        <td>{isFinite(item.PricePerSqft) ? getFormattedCurrency(item.PricePerSqft) : '-'}</td>
                                        <td>{item.DaysOnMarket}</td>
                                    </tr> : null;
                            })}
                            {viewMore && <tr>
                                <td colSpan={5}>
                                    <button className="btn btn-link view_btn" onClick={() => this.setState({ tableExpanded: !this.state.tableExpanded })}>
                                        {this.state.tableExpanded ? 'View Less' : viewMore}
                                    </button>
                                </td>
                            </tr>}
                        </tbody>
                    </Table>
                    :
                    <div className='no_sale_table'>No Sales History Available</div>}
            </div>
        </div>)
    }
}

export default SalesHistoryTable;